import React, {ReactElement} from "react";

import {AddressObjectType, FormGroupBase} from "/src/types";
import {BOOLEAN_OPTIONS} from "../../form-conditions/field-conditions/conditional-field-registry";
import translate from "/src/utils/translate";

import SingleSelect from "../../single-select/SingleSelect";
import AddressAutoComplete from "../address-auto-complete/AddressAutoComplete";

interface MailingPhysicalAddressProps extends FormGroupBase {
  placeholder?: string;
  transparentBg?: boolean;
  disableError?: boolean;
  onChange: (change: string | AddressObjectType) => unknown;
  valueForAddressField?: AddressObjectType;
}

const MailingPhysicalAddress = (
  props: MailingPhysicalAddressProps
): ReactElement => {
  const {
    placeholder = "",
    required = false,
    name = "",
    errorMessage = "",
    disabled = false,
    darkMode = false,
    transparentBg = false,
    onChange,
    valueForAddressField,
    disableError,
    status,
  } = props;

  const [sameAsMailing, setSameAsMailing] = React.useState<boolean>(false);

  const singleSelectOptions = [
    {
      label: translate("Yes"),
      value: BOOLEAN_OPTIONS.TRUE_VALUE,
    },
    {
      label: translate("No"),
      value: BOOLEAN_OPTIONS.FALSE_VALUE,
    },
  ];

  return (
    <>
      <AddressAutoComplete
        label={"Mailing Address"}
        required={required}
        name={name}
        key={`${name}-mailing`}
        errorMessage={errorMessage}
        disableError={disableError}
        darkMode={darkMode}
        transparentBg={transparentBg}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        addressType="mailing"
        valueForAddressField={valueForAddressField}
        sameAsMailing={sameAsMailing}
        status={status}
        disableAutoDuplication={true}
      />
      <SingleSelect
        label="Physical address is the same as mailing address?"
        name="same_as_mailing"
        value={BOOLEAN_OPTIONS.FALSE_VALUE}
        onChange={val => {
          setSameAsMailing(val === BOOLEAN_OPTIONS.TRUE_VALUE);
        }}
        options={singleSelectOptions}
        transparentBg={transparentBg}
        darkMode={darkMode}
      />
      <AddressAutoComplete
        label={"Physical Address"}
        required={required}
        name={name}
        key={`${name}-physical`}
        errorMessage={errorMessage}
        disableError={disableError}
        darkMode={darkMode}
        transparentBg={transparentBg}
        placeholder={placeholder}
        disabled={disabled || sameAsMailing}
        onChange={onChange}
        addressType="physical"
        valueForAddressField={valueForAddressField}
        sameAsMailing={sameAsMailing}
        status={status}
        disableAutoDuplication={true}
      />
    </>
  );
};

export default MailingPhysicalAddress;
